(function () {
  var root = document.documentElement;
  var body = document.body;
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var INVERT_STORAGE_KEY = 'npa-invert-mode';

  root.classList.remove('no-js');

  function setInvertMode(enabled) {
    root.setAttribute('data-invert-mode', enabled ? 'true' : 'false');

    var toggles = document.querySelectorAll('.invert-toggle');
    toggles.forEach(function (button) {
      button.setAttribute('aria-pressed', enabled ? 'true' : 'false');
      button.textContent = enabled ? 'Normal UI' : 'Invert UI';
    });
  }

  function initInvertMode() {
    var persisted = null;

    try {
      persisted = window.localStorage.getItem(INVERT_STORAGE_KEY);
    } catch (error) {
      persisted = null;
    }

    setInvertMode(persisted === 'true');

    document.querySelectorAll('.invert-toggle').forEach(function (button) {
      button.addEventListener('click', function () {
        var isEnabled = root.getAttribute('data-invert-mode') === 'true';
        var nextState = !isEnabled;

        setInvertMode(nextState);

        try {
          window.localStorage.setItem(INVERT_STORAGE_KEY, String(nextState));
        } catch (error) {
          /* localStorage can fail in restricted browsing modes */
        }
      });
    });
  }

  function initAnnouncementRotation() {
    if (reduceMotion) {
      return;
    }

    var wrappers = document.querySelectorAll('[data-announcement-rotate="true"]');

    wrappers.forEach(function (wrapper) {
      var items = wrapper.querySelectorAll('.announcement-bar__message');
      if (items.length < 2) {
        return;
      }

      var index = 0;
      window.setInterval(function () {
        items[index].classList.remove('is-active');
        index = (index + 1) % items.length;
        items[index].classList.add('is-active');
      }, 4000);
    });
  }

  function initBetaQueryFlag() {
    var params = new URLSearchParams(window.location.search);
    if (params.get('beta') === '1') {
      body.classList.add('beta-reveal');
    }
  }

  function initRandomGlitch() {
    if (reduceMotion) {
      return;
    }

    if (body.dataset.randomGlitch !== 'true') {
      return;
    }

    var targets = Array.prototype.slice.call(document.querySelectorAll('[data-glitch]'));
    if (targets.length === 0) {
      return;
    }

    function pulse() {
      var target = targets[Math.floor(Math.random() * targets.length)];
      target.classList.add('is-glitching');
      window.setTimeout(function () {
        target.classList.remove('is-glitching');
      }, 250);
    }

    window.setInterval(pulse, 4200);
  }


  function initModals() {
    var openers = document.querySelectorAll('[data-modal-open]');
    if (openers.length === 0) {
      return;
    }

    function closeModal(modal) {
      if (!modal) return;
      modal.setAttribute('hidden', 'hidden');
      document.body.classList.remove('modal-open');
    }

    function openModal(modal) {
      if (!modal) return;
      modal.removeAttribute('hidden');
      document.body.classList.add('modal-open');
    }

    openers.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var modalId = trigger.getAttribute('data-modal-open');
        var modal = document.querySelector('[data-modal="' + modalId + '"]');
        openModal(modal);
      });
    });

    document.querySelectorAll('[data-modal-close]').forEach(function (closer) {
      closer.addEventListener('click', function () {
        closeModal(closer.closest('[data-modal]'));
      });
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      var visible = document.querySelector('[data-modal]:not([hidden])');
      closeModal(visible);
    });
  }

  function initProductLightbox() {
    document.querySelectorAll('[data-pdp-gallery]').forEach(function (gallery) {
      var lightbox = gallery.querySelector('[data-pdp-lightbox]');
      if (!lightbox) {
        return;
      }

      var slides = Array.prototype.slice.call(lightbox.querySelectorAll('[data-pdp-lightbox-slide]'));
      if (slides.length === 0) {
        return;
      }

      var counter = lightbox.querySelector('[data-pdp-lightbox-counter]');
      var closeButton = lightbox.querySelector('.pdp-lightbox__close');
      var prevButton = lightbox.querySelector('[data-pdp-lightbox-prev]');
      var nextButton = lightbox.querySelector('[data-pdp-lightbox-next]');
      var currentIndex = 0;
      var lastFocused = null;
      var touchStartX = null;
      var touchStartY = null;

      function showSlide(index) {
        currentIndex = (index % slides.length + slides.length) % slides.length;
        slides.forEach(function (slide, slideIndex) {
          slide.classList.toggle('is-active', slideIndex === currentIndex);
        });
        if (counter) {
          counter.textContent = currentIndex + 1 + ' / ' + slides.length;
        }
      }

      function openLightbox(index) {
        lastFocused = document.activeElement;
        showSlide(index);
        lightbox.removeAttribute('hidden');
        body.classList.add('modal-open');
        if (closeButton) {
          closeButton.focus();
        }
      }

      function closeLightbox() {
        lightbox.setAttribute('hidden', 'hidden');
        body.classList.remove('modal-open');
        if (lastFocused && typeof lastFocused.focus === 'function') {
          lastFocused.focus();
        }
      }

      gallery.querySelectorAll('[data-pdp-lightbox-open]').forEach(function (opener) {
        opener.addEventListener('click', function () {
          var index = parseInt(opener.getAttribute('data-pdp-lightbox-open'), 10);
          openLightbox(isNaN(index) ? 0 : index);
        });
      });

      lightbox.querySelectorAll('[data-pdp-lightbox-close]').forEach(function (closer) {
        closer.addEventListener('click', closeLightbox);
      });

      if (prevButton) {
        prevButton.addEventListener('click', function () {
          showSlide(currentIndex - 1);
        });
      }

      if (nextButton) {
        nextButton.addEventListener('click', function () {
          showSlide(currentIndex + 1);
        });
      }

      document.addEventListener('keydown', function (event) {
        if (lightbox.hasAttribute('hidden')) {
          return;
        }

        if (event.key === 'Escape') {
          closeLightbox();
          return;
        }

        if (slides.length > 1 && event.key === 'ArrowLeft') {
          showSlide(currentIndex - 1);
          return;
        }

        if (slides.length > 1 && event.key === 'ArrowRight') {
          showSlide(currentIndex + 1);
          return;
        }

        if (event.key === 'Tab') {
          var focusable = lightbox.querySelectorAll('button');
          if (focusable.length === 0) {
            return;
          }
          var first = focusable[0];
          var last = focusable[focusable.length - 1];
          if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last.focus();
          } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first.focus();
          }
        }
      });

      lightbox.addEventListener(
        'touchstart',
        function (event) {
          if (event.touches.length !== 1) {
            touchStartX = null;
            return;
          }
          touchStartX = event.touches[0].clientX;
          touchStartY = event.touches[0].clientY;
        },
        { passive: true }
      );

      lightbox.addEventListener(
        'touchend',
        function (event) {
          if (touchStartX === null || slides.length < 2) {
            touchStartX = null;
            return;
          }
          var deltaX = event.changedTouches[0].clientX - touchStartX;
          var deltaY = event.changedTouches[0].clientY - touchStartY;
          touchStartX = null;
          if (Math.abs(deltaX) < 48 || Math.abs(deltaX) < Math.abs(deltaY)) {
            return;
          }
          showSlide(deltaX < 0 ? currentIndex + 1 : currentIndex - 1);
        },
        { passive: true }
      );
    });
  }

  function initVariantFeaturedMedia() {
    document.querySelectorAll('[data-pdp-gallery]').forEach(function (gallery) {
      var dataElement = gallery.querySelector('[data-pdp-variant-media]');
      var featuredButton = gallery.querySelector('.product-main__zoom');
      var featuredImage = featuredButton ? featuredButton.querySelector('img') : null;
      if (!dataElement || !featuredImage) {
        return;
      }

      var mediaByVariant;
      try {
        mediaByVariant = JSON.parse(dataElement.textContent);
      } catch (error) {
        return;
      }

      gallery.addEventListener('variant:change', function (event) {
        var media = mediaByVariant[String(event.detail.variantId)];
        if (!media) {
          return;
        }
        featuredImage.src = media.src;
        featuredImage.srcset = media.srcset;
        featuredImage.alt = media.alt;
        if (media.width && media.height) {
          featuredImage.width = media.width;
          featuredImage.height = media.height;
        }
        featuredButton.setAttribute('data-pdp-lightbox-open', String(media.index));
        featuredButton.setAttribute('aria-label', 'View larger image of ' + media.alt);
      });
    });
  }

  function initVariantPicker() {
    document.querySelectorAll('[data-pdp-gallery]').forEach(function (gallery) {
      var form = gallery.querySelector('.product-form');
      var variantsElement = gallery.querySelector('[data-pdp-variants]');
      var idInput = form ? form.querySelector('input[name="id"][data-variant-id]') : null;
      if (!form || !variantsElement || !idInput) {
        return;
      }

      var variants;
      try {
        variants = JSON.parse(variantsElement.textContent);
      } catch (error) {
        return;
      }

      var pickers = Array.prototype.slice.call(form.querySelectorAll('[data-option-picker]'));
      if (pickers.length === 0) {
        return;
      }

      // form.id would return the <input name="id"> control (named-property
      // shadowing), so read the attribute for the real element id.
      var formId = form.getAttribute('id');
      var buyButtons = Array.prototype.slice.call(
        gallery.querySelectorAll('button[name="add"], button[form="' + formId + '"]')
      );
      buyButtons.forEach(function (button) {
        button.dataset.defaultLabel = button.textContent.trim();
      });

      function setBuyState(disabled, label) {
        buyButtons.forEach(function (button) {
          button.disabled = disabled;
          button.textContent = label || button.dataset.defaultLabel;
        });
      }

      function selectedOptions() {
        return pickers.map(function (picker) {
          return picker.querySelector('[data-option-input]').value;
        });
      }

      function resolveVariant() {
        var options = selectedOptions();
        var match = variants.filter(function (variant) {
          return options.every(function (value, index) {
            return variant['option' + (index + 1)] === value;
          });
        })[0];

        if (!match) {
          setBuyState(true, 'Unavailable');
          return;
        }

        idInput.value = match.id;
        if (match.available) {
          setBuyState(false);
        } else {
          setBuyState(true, 'Sold out');
        }
        gallery.dispatchEvent(new CustomEvent('variant:change', { detail: { variantId: match.id } }));
      }

      pickers.forEach(function (picker) {
        picker.querySelector('[data-option-input]').addEventListener('change', resolveVariant);
      });
    });
  }

  function initThumbStrip() {
    document.querySelectorAll('[data-thumb-strip]').forEach(function (strip) {
      var track = strip.querySelector('[data-thumb-track]');
      var prevButton = strip.querySelector('[data-thumb-prev]');
      var nextButton = strip.querySelector('[data-thumb-next]');
      if (!track || !prevButton || !nextButton) {
        return;
      }

      function updateArrows() {
        var maxScroll = track.scrollWidth - track.clientWidth;
        if (maxScroll <= 1) {
          prevButton.hidden = true;
          nextButton.hidden = true;
          return;
        }
        prevButton.hidden = false;
        nextButton.hidden = false;
        prevButton.disabled = track.scrollLeft <= 1;
        nextButton.disabled = track.scrollLeft >= maxScroll - 1;
      }

      function page(direction) {
        track.scrollBy({
          left: direction * track.clientWidth,
          behavior: reduceMotion ? 'auto' : 'smooth'
        });
      }

      prevButton.addEventListener('click', function () {
        page(-1);
      });
      nextButton.addEventListener('click', function () {
        page(1);
      });
      track.addEventListener('scroll', updateArrows, { passive: true });
      window.addEventListener('resize', updateArrows);
      updateArrows();
    });
  }

  function initStickyATCVisibility() {
    var sticky = document.querySelector('[data-sticky-atc]');
    if (!sticky) {
      return;
    }

    if (!('IntersectionObserver' in window)) {
      return;
    }

    var form = document.querySelector('.product-form');
    if (!form || reduceMotion) {
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            sticky.style.opacity = '0';
            sticky.style.pointerEvents = 'none';
          } else {
            sticky.style.opacity = '1';
            sticky.style.pointerEvents = 'auto';
          }
        });
      },
      { threshold: 0.15 }
    );

    observer.observe(form);
  }

  initInvertMode();
  initAnnouncementRotation();
  initBetaQueryFlag();
  initRandomGlitch();
  initProductLightbox();
  initVariantFeaturedMedia();
  initVariantPicker();
  initThumbStrip();
  initStickyATCVisibility();
  initModals();
})();
